import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
var TruncateByLines = styled(Box).withConfig({
  componentId: "dim94d-0"
})(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], function (_ref) {
  var limit = _ref.limit;
  return limit;
});
var Styled = {
  TruncateByLines: TruncateByLines
};
export { Styled };